import { orderTotalDisplayStyles } from "@insite/content-library/Components/OrderTotalDisplay";
import { css } from "styled-components";

Object.assign(orderTotalDisplayStyles, {
    container: {
        gap: 10,
        css: css`
            background-color: rgb(237, 244, 248);
            padding: 20px;
            border-radius: 8px;
        `,
    },
});
